<template>
    <div>

        <v-chip label v-if="status == -1" color="red darken-4" text-color="#FFFFFF">
            Taken off and Canceled
            </v-chip>
    	    <v-chip label v-if="status == 0" color="red darken-3" text-color="#FFFFFF">
    	    Cancelled
    	    </v-chip>
            <!--<v-chip label v-if="status == 1" color="yellow darken-3" text-color="#FFFFFF">
            READY
            </v-chip>
    	     <v-chip label v-if="status == 2" color="green" text-color="#FFFFFF">
    	    READY
    	    </v-chip> -->
    	    <v-chip label v-if="status == 3" color="green" text-color="#FFFFFF">
    	    In Progress
    	    </v-chip>
    	    <v-chip label v-if="status == 4" color="blue lighten-1" text-color="#FFFFFF">
    	    Landed
    	    </v-chip>
            <!-- <v-chip label v-if="status == 4" color="blue lighten-1" text-color="#FFFFFF">
            Landed

            </v-chip> -->
    </div>
</template>

<script>
export default {
	props : ['status'],
	data: () => ({

      options : [
                { id : -2, text: "Refunded", color : "gray lighten-3" },
                { id : -1, text: "Taken off and Canceled", color : "red darken-3" },
                { id : 0, text: "Cancelled", color : "red darken-3" },
                { id : 2, text: "READY", color : "green"},
                { id : 3, text: "In Progress", color : "green lighten-5" },
                { id : 4, text: "Landed", color : "blue lighten-1"},
                ]
    }),

    methods : {

    	getStatus(val) {//para poner el color

            const index = this.options.map(function (s) { return s.id; }).indexOf(val);
            return this.options[index]

          },
    }
}
</script>

<style>

</style>
